var sliceStr = '::';
export default function errorHandle(err, message, extendObj) {
    if (extendObj === void 0) { extendObj = {}; }
    var type = 'NO_DEFINE';
    if (err instanceof Error) {
        if (err.type) {
            type = err.type;
        }
        message = err.message;
        err = { type: type, message: message, error: err };
    }
    else if (typeof err === 'string') {
        var index = err.indexOf(sliceStr);
        if (index > -1) {
            type = err.slice(0, index);
            message = err.slice(index + sliceStr.length);
        }
        else if (message) {
            type = err;
        }
        else {
            message = err;
        }
        err = { type: type, message: message };
    }
    Object.assign(err, extendObj);
    return err;
}
